import {
  FETCH_REFERRALS_REQUEST,
  FETCH_REFERRALS_SUCCESS,
  FETCH_REFERRALS_FAILURE,
} from "./types";

import { fetchReferralStats } from "../../services/referralService";

export const fetchReferralsAction = (page = 1, size = 10) => async (dispatch) => {
  dispatch({ type: FETCH_REFERRALS_REQUEST });

  try {
    const response = await fetchReferralStats(page, size);

    if (response.success) {
      dispatch({
        type: FETCH_REFERRALS_SUCCESS,
        payload: response.data,
      });
    } else {
      dispatch({
        type: FETCH_REFERRALS_FAILURE,
        payload: response.error,
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_REFERRALS_FAILURE,
      payload: error.message,
    });
  }
};